import { useEffect, useState } from 'react'
import { getFeedPosts, getTrendingTopics as apiGetTrendingTopics } from '../services/posts'
import { computeTrendingFromPosts } from '../utils/hashtags'

export default function useTrendingTopics(limit = 10, enabled = true) {
  const [topics, setTopics] = useState([])
  const [loading, setLoading] = useState(enabled)

  useEffect(() => {
    if (!enabled) return
    let alive = true

    async function load() {
      try {
        const fromApi = await apiGetTrendingTopics()
        if (fromApi?.length) {
          if (alive) setTopics(fromApi.slice(0, limit))
          return
        }
      } catch {
        // fall through to client-side fallback
      }

      try {
        const data = await getFeedPosts(null, 100)
        if (alive) setTopics(computeTrendingFromPosts(data.posts ?? [], limit))
      } catch {
        if (alive) setTopics([])
      }
    }

    load().finally(() => { if (alive) setLoading(false) })

    return () => { alive = false }
  }, [limit, enabled])

  return { topics, loading }
}